import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';

export const AssistedBirth = () => {
    const { chartData } = useBirthChartsDataContext();


    return (
        <SimpleBars
            title={'Nascimento Assistido'}
            horizontal={false}
            subtitles={chartData?.assistedBirth?.map((item) => item.description)}
            values={chartData?.assistedBirth?.map((item) => item.total  ||  0)}
        />
    );
};
